import * as u from './utils';

export default () => {
    const container = document.querySelectorAll('.stepped-text');

    if (!container) {
        return;
    }

    for (const el of container) {
        const items = Array.prototype.slice.call(el.querySelectorAll('.stepped-text__item'));
        const reverseItems = items.slice().reverse();

        const handleScroll = () => {
            u.removeClass(items, 'is-active');
            let found = false;
            for (let i = 0; i < reverseItems.length; i++) {
                if (reverseItems[i].getBoundingClientRect().top < window.innerHeight / 2) {
                    u.addClass(reverseItems[i], 'is-active');
                    found = true;
                    break;
                }
            }
            if (!found) {
                u.addClass(reverseItems[reverseItems.length - 1], 'is-active');
            }
        };

        window.addEventListener('scroll', handleScroll);
    }
};
